export const frameworkSteps = [
  { title: "Evaluate", body: "Organize the available patient information and identify the characteristics that deserve educational review." },
  { title: "Map", body: "Arrange the relevant observations, questions, and case-specific considerations." },
  { title: "Prepare", body: "Identify the information and professional references you want to review before studying the procedural concepts." },
  { title: "Sequence", body: "Organize your understanding of the educational procedure sequence using appropriate professional references." },
  { title: "Review", body: "Examine the case, record your questions, and compare your observations with the educational material." },
  { title: "Learn", body: "Document the concepts you reviewed, the questions that remain, and the lessons you want to revisit." },
];

export const storyQuestions = [
  "What should I review first?",
  "Which patient characteristics deserve closer attention?",
  "How do I organize the information I've gathered?",
  "How can I connect the different concepts I've studied?",
  "Which questions should I investigate before moving forward?",
];

export const painPoints = [
  {
    title: "You have too many resources and no consistent review process.",
    body: "One lecture explains a concept. Another discusses a different technique. Your notes are scattered across multiple documents. You spend valuable study time trying to connect everything.",
  },
  {
    title: "You understand individual concepts but struggle to organize the complete picture.",
    body: "You have studied patient assessment, facial anatomy, surgical approaches, and postoperative considerations. But when you review a case, you want a more consistent way to organize the information.",
  },
  {
    title: "Every case raises a different set of questions.",
    body: "Patient characteristics, facial anatomy, aesthetic objectives, tissue quality, and previous procedures can all influence the questions that deserve attention. You want a framework that helps you organize those variables without treating every case as identical.",
  },
  {
    title: "You consume educational content passively.",
    body: "You watch another lecture. You read another article. You attend another conference. But you don't always have a structured way to apply what you've studied to educational case exercises.",
  },
  {
    title: "Your case-review notes are inconsistent.",
    body: "Sometimes you document your observations carefully. Other times, you finish studying without recording the questions you still have or the concepts you want to revisit.",
  },
  {
    title: "You want to make better use of your study time.",
    body: "You don't necessarily need more information. You need a better way to organize, review, and retain the information you're already working with.",
  },
];

export const beforeItems = [
  "Jumping between different educational resources.",
  "Organizing each case differently.",
  "Struggling to connect individual concepts.",
  "Finishing study sessions without documenting what you learned.",
  "Losing track of questions that need further investigation.",
  "Reconstructing your notes every time you revisit a subject.",
];

export const afterItems = [
  "Organize your review of facelift cases.",
  "Document observations using consistent worksheets.",
  "Identify questions that deserve further study.",
  "Compare educational cases using the same structure.",
  "Keep a record of the references you've consulted.",
  "Document your learning points.",
  "Build a personal archive of your educational sessions.",
];

export const guaranteeItems = [
  "Explore all six volumes.",
  "Review the complete educational framework.",
  "Work through the case exercises.",
  "Use the planning worksheets.",
  "Test the review checklists.",
  "Explore the five bonuses.",
  "Decide whether the system is useful for your professional education.",
];
